import * as XLSX from "xlsx";

export const exportAccessMatrixToExcel = (users, systems) => {
  try {
    const exportData = [];
    
    const headerRow = ["User", "Email", "Role"];
    systems.forEach(system => {
      headerRow.push(system.label);
    });
    exportData.push(headerRow);
    
    users.forEach(user => {
      const row = [
        user.name || "Unknown User",
        user.email || "-",
        user.orgRole || "-"
      ];
      
      systems.forEach(system => {
        const access = user.systemAccess[system.id];
        if (access) {
          row.push(access.role || "No Role");
        } else {
          row.push("N/A");
        }
      });
      
      exportData.push(row);
    });
    
    const ws = XLSX.utils.aoa_to_sheet(exportData);
    
    const colWidths = [
      { wch: 25 }, // User
      { wch: 30 }, // Email
      { wch: 20 }, // Role
    ];
    systems.forEach(() => {
      colWidths.push({ wch: 20 }); // System columns
    });
    ws['!cols'] = colWidths;
    
    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Access Matrix");
    
    // Generate filename with timestamp
    const timestamp = new Date().toISOString().split('T')[0];
    const filename = `Access_Matrix_${timestamp}.xlsx`;
    
    // Download file
    XLSX.writeFile(wb, filename);
    
    return { success: true };
  } catch (error) {
    console.error("Export failed:", error);
    return { success: false, error };
  }
};

